import styled from "styled-components";

export const FormWrapper = styled.div`
    width: 100%;

    .ant-form-item {
        margin-bottom: 12px;
    }

    @media (max-width: 768px) {
        .ant-form-item-label > label {
            font-size: 13px;
        }

        .ant-input,
        .ant-select-selector {
            font-size: 13px !important;
        }
    }
`;

export const FormRow = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;

    @media (max-width: 768px) {
        gap: 12px;
    }
`;

export const CityDisplayText = styled.span`
    border: 1px solid #dedede;
    padding: 10px 15px;
    display: inline-block;

    @media (max-width: 768px) {
        padding: 6px 10px;
        font-size: 13px;
        width: 100%;
        box-sizing: border-box;
    }
`;

export const CompaniesSection = styled.div`
    width: 100%;

    > label {
        display: block;
        margin-bottom: 10px;
    }

    @media (max-width: 768px) {
        > label {
            font-size: 13px;
            margin-bottom: 8px;
        }
    }
`;

export const CompanyTableWrapper = styled.div`
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;

    .ant-table {
        min-width: 500px;
    }

    @media (max-width: 768px) {
        margin: 0 -4px;
        padding: 0 4px;

        .ant-table-cell {
            font-size: 11px;
            padding: 4px 6px !important;
            white-space: nowrap;
        }

        .ant-tag {
            font-size: 11px;
            margin-right: 0;
            padding: 0 4px;
        }

        .ant-btn-sm {
            font-size: 11px;
            padding: 0 6px;
        }

        .ant-input-search {
            width: 100% !important;
        }
    }
`;

export const SwitchRow = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 16px;

    @media (max-width: 768px) {
        flex-direction: row;
        justify-content: space-around;
        gap: 12px;
    }
`;

export const SwitchItem = styled.div`
    min-width: 160px;
    text-align: center;

    @media (max-width: 768px) {
        min-width: 0;
        flex: 1;
    }
`;

export const SwitchLabel = styled.div`
    margin-bottom: 8px;

    @media (max-width: 768px) {
        font-size: 13px;
        margin-bottom: 6px;
    }
`;

export const SubmitRow = styled.div`
    display: flex;
    justify-content: flex-end;

    @media (max-width: 768px) {
        .ant-btn {
            width: 100%;
        }
    }
`;

export const MapRow = styled.div`
    margin-top: 20px;
    width: 100%;

    @media (max-width: 768px) {
        margin-top: 12px;
        margin-left: -4px;
        margin-right: -4px;
        width: calc(100% + 8px);
    }
`;
